<template>
  <div class="exception">
    <van-empty :description="sourceData.title" :image="sourceData.imageUrl">
    </van-empty>
  </div>
</template>

<script>
import { Empty } from 'vant';
import '@/styles/theme/resetVantUI.less';

export default {
  name: 'Exception',
  props: {
    sourceData: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    [Empty.name]: Empty,
  },
};
</script>

<style style="less">
.exception {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
